import { render } from "./Show.vue?vue&type=template&id=52690a1b&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=52690a1b&scoped=true&lang=scss"
import "./Show.vue?vue&type=style&index=1&id=52690a1b&lang=scss"
script.render = render
script.__scopeId = "data-v-52690a1b"

export default script